/* eslint-disable @typescript-eslint/no-explicit-any */
import { InjectionToken } from '@angular/core';

//export const FUSE_CONFIG = new InjectionToken<any>('FUSE_APP_CONFIG');
export const FUSE_CONFIG = new InjectionToken<any>('OCTO_CONFIG');

export const APP_VERSION = '6.10.27.0';
export const APP_NAME = 'My Fleet';
